import React from 'react';
import { useTranslation } from 'react-i18next';
import { AftersalesOrder } from '@1po/1po-bff-fe-spec/generated/aftersales_order/model/AftersalesOrder';
import { Table } from 'antd-v5';
import { OrderDetailProps } from 'pages/MyOrdersPage/AscOrders/AscOrderDetail';
import { CenterFlex } from 'UI';
import { textFormatter } from 'utils';

const AscOrderDetailTotalTable = ({ orderDetail }: OrderDetailProps) => {
  const { t } = useTranslation();
  const getColumns = () => [
    {
      title: <CenterFlex>{t('common.price.total_VAT_excluded', 'Total VAT Excluded')}</CenterFlex>,
      dataIndex: 'totalVatExcluded',
      key: 'totalVatExcluded',
      render: (_value: string, row: AftersalesOrder) => {
        const { value, currency } = row;
        return (
          <CenterFlex>
            <>{textFormatter.formatCurrency(value ?? 0, currency)}</>
          </CenterFlex>
        );
      },
    },
  ];
  return <Table columns={getColumns()} dataSource={[orderDetail]} pagination={false}></Table>;
};

export default AscOrderDetailTotalTable;
